<template>
  <div class="firediamond">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      :width="size + (0.1 * size)"
      :height="size + (0.15 * size)">
      <g :transform="transform" >
        <rect
          :x="-1 * (third + (3 * squaremargin)) + offsetX"
          :y="-1 * (third + (3 * squaremargin)) + offsetY"
          :width="2 * (third + (3 * squaremargin))"
          :height="2 * (third + (3 * squaremargin))"/>
        <rect
          :x="-1 * (third + squaremargin) + offsetX"
          :y="-1 * (third + squaremargin) + offsetY"
          :width="third"
          :height="third"
          fill="#ff6666"/>
        <rect
          :x="-1 * (third + squaremargin) + offsetX"
          :y="squaremargin + offsetY"
          :width="third"
          :height="third"
          fill="#6691ff"/>
        <rect
          :x="squaremargin + offsetX"
          :y="-1 * (third + squaremargin) + offsetY"
          :width="third"
          :height="third"
          fill="#fcff66"/>
        <rect
          :x="squaremargin + offsetX"
          :y="squaremargin + offsetY"
          :width="third"
          :height="third"
          fill="#ffffff"/> -->
      </g>
      <text
        v-if="input.flammability"
        :style="number"
        :x="(size + squaremargin) / 2 + offsetX / 3"
        :y="quarter - squaremargin + offsetY * 3">
        {{ input.flammability }}
      </text>
      <text
        v-if="input.health_hazard"
        :style="number"
        :x="quarter - squaremargin + offsetX / 2"
        :y="((size + squaremargin) / 2) + offsetY * 2">
        {{ input.health_hazard }}
      </text>
      <text
        v-if="input.reactivity"
        :style="number"
        :x="3 * quarter + squaremargin + offsetX / 2"
        :y="((size + squaremargin) / 2) + offsetY * 2">
        {{ input.reactivity }}
      </text>
      <text
        v-if="input.special_notice"
        :style="special"
        :x="((size + squaremargin) / 2) + offsetX / 2"
        :y="3 * quarter + squaremargin + offsetY * 3">
        {{ input.special_notice && input.special_notice.toUpperCase() }}
      </text>
    </svg>
  </div>

</template>

<script>
export default {
  name: 'FireDiamond',
  props: {
    size: {
      type: [Number, String],
      default: 300 // size of the fire diamond
    },
    squaremargin: {
      type: [Number, String],
      default: 2 // size of the black margin
    },
    input: {
      type: Object
    }
  },
  computed: {
    third () {
      return (this.size / 3)
    },
    quarter () {
      return (this.size / 4)
    },
    transform () {
      const half = (this.size / 2)
      return 'translate(' + half + ',' + half + ') rotate(45)'
    },
    number () {
      return 'font-size:' + this.third + 'px;'
    },
    special () {
      return 'font-size:' + this.quarter / 2 + 'px;'
    },
    offsetX () {
      return this.size * 0.1
    },
    offsetY () {
      return this.size * 0.025
    }
  }
}
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px;
}
text {
  text-anchor: middle;
  alignment-baseline: central;
}
</style>
